<template>
  <!-- KPI de Estadística de diagnósticos -->
  <v-card flat class="pa-0 ma-0">
    <v-row dense>
      <!-- Tasa de homologación -->
      <v-col cols="12" md="4">
        <v-card outlined class="pa-4">
          <div class="caption mb-1">Tasa de Homologación</div>

          <div class="kpi-line">
            <span class="kpi-figure">{{ pct(hRate) }}</span>
            <span class="kpi-pill kpi-pill--success">
              {{ nf(stats.num_diagnosticos_homologados) }} /
              {{ nf(stats.num_diagnosticos_total) }}
            </span>
          </div>

          <v-progress-linear :value="hRate * 100" height="8" color="primary" class="mt-2"/>
        </v-card>
      </v-col>

      <!-- IA sobre homologados -->
      <v-col cols="12" md="4">
        <v-card outlined class="pa-4">
          <div class="caption mb-1">Homologaciones Realizadas por Intelgencia Artificial (IA)</div>

          <div class="kpi-line">
            <span class="kpi-figure">{{ pct(aiRate) }}</span>
            <span class="kpi-pill kpi-pill--info">
              {{ nf(stats.num_diagnosticos_homologados_ai) }} /
              {{ nf(stats.num_diagnosticos_homologados) }}
            </span>
          </div>

          <v-progress-linear :value="aiRate * 100" height="8" color="info" class="mt-2"/>
        </v-card>
      </v-col>

      <!-- % Impacto de Diagnósticos Pendientes de Homologación -->
      <v-col cols="12" md="4">
        <v-card outlined class="pa-4">
          <v-tooltip bottom max-width="420" color="#000000">
            <template v-slot:activator="{ on, attrs }">
              <div class="caption mb-1 font-weight-medium d-flex align-center" v-bind="attrs" v-on="on">
                % Impacto de Diagnósticos Pendientes de Homologación
                <v-icon small color="grey lighten-1" class="ml-1">mdi-information-outline</v-icon>
              </div>
            </template>

            <div class="tooltip-content">
              <div class="mb-1 font-weight-medium">Interpretación</div>
              <table class="tooltip-table">
                <tr>
                  <th style="width: 25%;">Rango</th>
                  <th style="width: 25%;">Nivel</th>
                  <th style="width: 50%;">Descripción</th>
                </tr>
                <tr>
                  <td class="text-center">0 % – 5 %</td>
                  <td class="text-center">🟢 Bajo</td>
                  <td>Los diagnósticos pendientes son poco frecuentes y no afectan significativamente la operación.</td>
                </tr>
                <tr>
                  <td class="text-center">5 % – 15 %</td>
                  <td  class="text-center">🟠 Medio</td>
                  <td>Algunos diagnósticos comunes siguen sin homologar, conviene priorizar su revisión.</td>
                </tr>
                <tr>
                  <td class="text-center">Mas de 15 %</td>
                  <td  class="text-center">🔴 Alto</td>
                  <td>Gran parte de las consultas utilizan diagnósticos sin homologar. Se recomienda intervención prioritaria.</td>
                </tr>
              </table>
            </div>
          </v-tooltip>

          <div class="kpi-line">
            <span class="kpi-figure">{{ pct(stats.por_impacto_diagnosticos_faltantes) }}</span>
          </div>

          <v-progress-linear
            :value="stats.por_impacto_diagnosticos_faltantes * 100"
            :color="impactColor"
            height="8"
            class="mt-2"
          />
        </v-card>
      </v-col>

    </v-row>
  </v-card>
</template>

<script>

import axios from 'axios'

export default {
  data: () => ({
    loadingStats: false,
    stats: {
      num_diagnosticos_total: 0,
      num_diagnosticos_homologados: 0,
      num_diagnosticos_homologados_ai: 0,
      por_impacto_diagnosticos_faltantes: 0,
    }
  }),
  computed: {
    hRate () {
      const t = this.stats.num_diagnosticos_total || 0
      const h = this.stats.num_diagnosticos_homologados || 0
      return t > 0 ? h / t : 0
    },
    aiRate () {
      const h = this.stats.num_diagnosticos_homologados || 0
      const ai = this.stats.num_diagnosticos_homologados_ai || 0
      return h > 0 ? ai / h : 0
    }
  },
  methods: {
    async getStats () {
      this.loadingStats = true;

      axios
      .get(`/DiagnosticoMedicoHeterogeneo/Estadisticas`)
      .then(response => {
        this.stats = response.data;
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.loadingStats = false;
      })
    },
    pct (v) {
      return `${(v * 100).toFixed(1)}%`
    },
    nf (n) {
      return new Intl.NumberFormat('es-MX').format(n || 0)
    }
  },
  created () {
    this.getStats()
  }
}
</script>

<style scoped>
.kpi-line {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.kpi-figure {
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1;
}

.kpi-pill {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.85rem;
  line-height: 1.2;
  border: 1px solid transparent;
}

/* Variantes de color (ajústalas a tu paleta Vuetify si quieres) */
.kpi-pill--success {
  background: #e8f5e9;   /* green lighten-5 */
  color: #2e7d32;        /* green darken-3 */
  border-color: #c8e6c9; /* green lighten-4 */
}

.kpi-pill--info {
  background: #e3f2fd;   /* blue lighten-5 */
  color: #1565c0;        /* blue darken-3 */
  border-color: #bbdefb; /* blue lighten-4 */
}

.kpi-pill--warning {
  background: #fff8e1;   /* amber lighten-5 */
  color: #ef6c00;        /* orange darken-3 */
  border-color: #ffe0b2; /* orange lighten-4 */
}
</style>
